import { Theme as _Theme } from '@livecontrol/core-ui';
import { useMemo, useState } from 'react';
import type { PropsWithChildren, ReactElement } from 'react';
import { Context } from './context';
import type { Theme } from './theme';

const themeConfig: Record<Theme.Name, Required<_Theme.Provider.Loader>> = {
  base: {
    component: async () => import(/* webpackChunkName: "base-theme" */ './base'),
    variant: 'dark'
  }
};

export const Provider = ({
  children,
  defaultTheme = 'base',
  ...rest
}: Provider.Props): ReactElement => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const [theme, setTheme] = useState(themeConfig[defaultTheme] ? defaultTheme : 'base');
  const { variant } = themeConfig[theme];

  const themeValue = useMemo(
    () => ({
      setTheme
    }),
    [setTheme]
  );

  return (
    <Context.Provider value={themeValue}>
      <_Theme.Provider loaders={themeConfig} themeName={theme} {...rest}>
        <div className={`x-${variant}-theme`}>{children}</div>
      </_Theme.Provider>
    </Context.Provider>
  );
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export namespace Provider {
  export type Props = PropsWithChildren<{ defaultTheme?: Theme.Name }>;
}
